var React = require('react');

function Empty (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M12.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 2a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z","id":"empty-a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"empty-b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#empty-a"})),React.createElement("use",{"fill":"#979797","fillRule":"nonzero","xlinkHref":"#empty-a","key":1}),React.createElement("g",{"mask":"url(#empty-b)","key":2},[React.createElement("path",{"fill":"#FFF","d":"M0 0h25v25H0z","key":0}),React.createElement("path",{"fill":"#424242","d":"M0 0h25v25H0z","key":1})])])]);
}

Empty.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Empty;

Empty.default = Empty;
